import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { Container } from '@mui/material';

export const VantagensContainer = styled(Container)` 
  background: ${({ theme }) => theme.COLORS.BACKGROUND_BLUE};
  display: flex !important;
  justify-content: center;
  padding: 14rem 2rem;
  padding-top: 0;

 


  @media (max-width: 1500px) {
    padding: 12rem 2rem;
    padding-top: 0;
  }

`;

export const Slide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 1.5rem 8rem; 
  
  h1 {
    font-family: 'Mont-Medium';
    font-size: clamp(1.6rem, 3.4vw, 3.6rem); 
    color: ${({ theme }) => theme.COLORS.YELLOW};
    margin-bottom: 2rem;
  }

  p {
    font-family: 'Mont-Light';
    font-size: clamp(1.4rem, 2.8vw, 2.2rem); 
    color: ${({ theme }) => theme.COLORS.WHITE};
    margin: 0.5rem 0 1rem;
    line-height: 1.4; 
  }

  img {
    width: 20rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem; 
  }


  @media (max-width: 1500px) {
    padding: 1.5rem 7rem; 

    h1 {    
    font-size: clamp(2rem, 3.4vw, 2.2rem); 
  }

  p {
    font-size: clamp(1.4rem, 2.8vw, 1.6rem); 
  }

  img {
    width: 12rem;
  }

}

@media (max-width: 1100px) {
    padding: 1.5rem 2rem; 

  img {
    width: 10rem;
  }
}


@media (max-width: 900px) {
    padding: 1.5rem 6rem; 
}


@media (max-width: 700px) {
    padding: 1.5rem 2rem; 
}

`;

export const StyledSlider = styled(Slider)`
  width: 100%;
  
  .slick-slide > div {
    display: flex;
    justify-content: center;
  }

  .slick-dots {
   position: absolute;
   bottom: -10rem;

  li {
    margin: 0 1.6rem; 


    button:before {
      color: transparent;
    }

 
    button {
      border: 1px solid ${({ theme }) => theme.COLORS.WHITE}; 
      background-color: transparent;
      border-radius: 50%;
      width: 2.4rem;
      height: 2.4rem;


      &:hover {
        background-color: ${({ theme }) => theme.COLORS.YELLOW};
        border: 1px solid ${({ theme }) => theme.COLORS.YELLOW};
      }
    }

    &.slick-active button {
      background-color: ${({ theme }) => theme.COLORS.YELLOW};
      border: 1px solid ${({ theme }) => theme.COLORS.YELLOW};
    }
  }
}


  .slick-prev,
  .slick-next {
    display: none !important;
  }

  @media (max-width: 500px) {
    .slick-dots {
      bottom: -7rem;
      height: 6rem;
      display: flex !important;
      flex-wrap: wrap;
      justify-content: center !important;
    

    li {
      margin: 0 .5rem; 

      button {
        width: 2rem;
        height: 2rem;
      }
    }
    }

  }
  

`;
